export enum ConditionalCheckboxValue {
  checked = "Y",
  unchecked = "N",
}
